import { useEffect, useState } from 'react';
import { Context } from '../../types/frontastic';
import ClientFactory from '../algolia/ClientFactory';
import StoreService from '../algolia/StoreService';

export default function useQueryStore(context: Context): string | null {
  const [refererStore, setRefererStore] = useState<any | null>(null);

  useEffect(() => {
    const fetchRefererStore = async () => {
      const objectIdParam = new URLSearchParams(window.location.search).get('objectId');

      if (objectIdParam) {
        const response = await ClientFactory.queryStore(context, '', {
          facetFilters: `objectID:${objectIdParam}`,
        });

        const hit = (response.results?.[0] as any)?.hits?.[0];
        if (hit) {
          setRefererStore(StoreService.formatStoreForCookie(hit));
        }
      }
    };

    fetchRefererStore();
  }, [context]);

  return refererStore;
}
